import React, { useEffect, useState } from "react";
import { postContratosXEmpresa } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaContratosXEmpresaN from "./TablaContratosXEmpresaN";

const ModalListaDeSeleccionContratosXEmpresaN = ({
  setmodalOnContratosXUsuario,
  passDataUser,
  passactualizarinfo
}) => {
  const [dataContratrosXEmpresa, setdataContratrosXEmpresa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [guardarContratosXEmpresa, setguardarContratosXEmpresa]=useState({    
    MENNIT: '',
    MPTDoc: "",
    MPCedu: "",
    MTCodP: "",
    MTUCod: ""
  })
  const handleCancelarClick = () => {
    setmodalOnContratosXUsuario(false);
  };

  const passdatoscontratosxempresa=(data)=>{
    passactualizarinfo(data)
    setmodalOnContratosXUsuario(false);
    setguardarContratosXEmpresa(data)
  }



  const handleOnsubmitBuscar = (e) => {
    e.preventDefault();
    setLoading(false);
    const body = {
      varMENOMB: e.target.nombre.value,
      varMEestado: "0",
      varMTUEstado: "A",
      varMTTEstado: "A",
      varMeIndCap: "N",
    };
    postContratosXEmpresa(body).then((res) => {
      setLoading(true);
      setdataContratrosXEmpresa(res.data);
      //console.log(res.data,'contratos x empresa')
    });
  };

  useEffect(() => {
    const body = {
      varMENOMB: "",
      varMEestado: "0",
      varMTUEstado: "A",
      varMTTEstado: "A",
      varMeIndCap: "N",
      //MPstatus:'A'
    };
    postContratosXEmpresa(body).then((res) => {
      setLoading(true);
      setdataContratrosXEmpresa(res.data);
      //console.log(res.data,'contratos x empresa')
    });
  }, []);
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-0.5 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Lista de Selección Contratos X Empresa-
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative ">
            <form onSubmit={handleOnsubmitBuscar}>
              <div className="flex py-2 text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Desc. Contrato
                  </label>
                  <div className="flex">
                    <input                      
                      type="text"
                      name="nombre"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                  <div className="flex">
                    <button
                      type="submit"
                      className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-4 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            ID. Contrato
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Desc. Contrato
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Cd-
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Cd-
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Afiliado
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          dataContratrosXEmpresa.map((item, index) => (
                            <TablaContratosXEmpresaN key={index} item={item} passDataUser={passDataUser} passdatoscontratosxempresa={passdatoscontratosxempresa}/>
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-left">
                              <Loading />
                            </td>
                          </tr>
                        )}                        
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalListaDeSeleccionContratosXEmpresaN;
